import { AdvancedSearchConfig } from "../forms/advanced-search/advanced-search-fields-def";
import { ColumnFormatted } from "./general";

export const publicAuctionColumns: ColumnFormatted[] = [
  { type: "string", key: "ventesDescriptionNumeroVente", visible: true },
  { type: "boolean", key: "ventesDescriptionCatalogue", visible: true },
  { type: "string", key: "ventesDescriptionTitre", visible: true },
  { type: "string", key: "ventesDescriptionDate", visible: true },
  { type: "string", key: "ventesDescriptionCommissaires", visible: true },
  { type: "string", key: "ventesDescriptionLieu", visible: true },
  { type: "string", key: "ventesDescriptionSalle", visible: true },
  { type: "string", key: "ventesDescriptionVille", visible: true },
  { type: "string", key: "ventesDescriptionPays", visible: false },
  { type: "richtext", key: "ventesDescriptionNotesVente", visible: false },
  { type: "richtext", key: "ventesDescriptionResume", visible: false },
  { type: "status", key: "ventesPublicationStatus", visible: true },
  { type: "richtext", key: "sources", visible: false },
];

export const publicAuctionAdvancedSearchConfig: AdvancedSearchConfig = [
  {
    type: "group",
    label: "publicAuctionDescription",
    fields: [
      { type: "string", key: "ventesDescriptionNumeroVente" },
      { type: "boolean", key: "ventesDescriptionCatalogue" },
      { type: "string", key: "ventesDescriptionTitre" },
      { type: "string", key: "ventesDescriptionDate" },
      { type: "string", key: "ventesDescriptionCommissaires" },
      { type: "string", key: "ventesDescriptionLieu" },
      { type: "string", key: "ventesDescriptionSalle" },
      { type: "string", key: "ventesDescriptionVille" },
      { type: "string", key: "ventesDescriptionPays" },
    ],
  },
  {
    type: "group",
    label: "publicAuctionSources",
    fields: [{ type: "string", key: "sources" }],
  },
];
